export default {
  TitleControl: '',
  ShowTitleControl: { checked: false },
  SortValuesControl: 'Não ordenado',
  ColorTheme: { scheme: 'category10' },
  type: 'Waffle',
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
};
